export const ru = {
    title: 'Кому добавить услугу',
    description: 'После добавления услуги участники должны самостоятельно отправить заявку на оформление',
    add_service_error_message: 'Не удалось добавить услугу',
};
